import {Spinner} from "@heroui/spinner";
import {Icon} from "@iconify/react";
import {createFileRoute, useNavigate, useParams} from '@tanstack/react-router'
import React, {useEffect, useState} from "react";
import {apiRetrieve} from "../../../../api.ts";
import {config} from "../../../../config/config.ts";
import Header from "../../../../Header.tsx";
import PublicProfileView from "../../../../user/PublicProfileView.tsx";
import {MenuItemCard} from "../../../../user/User_ProfileView.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});
    const [profile, setProfile] = useState(null as any);
    const navigate = useNavigate();

    useEffect(() => {
        ;(async () => {
            const response = await apiRetrieve('public-player-profile', {player_uid: params.player_uid, club_uid: params.club_uid});
            console.log('response', response)
            if (response.player) {
                setProfile({...response.player});
            }
        })()
    }, [params.player_uid]);

    if (!profile) {
        return <>
            <Header />
            <div className="text-center"><Spinner /></div>
        </>
    }

    return (
        <>
            <Header />

            <div className="max-w-6xl w-11/12 mx-auto pb-8">
                <PublicProfileView profile={profile} isClubProfile={true} />

                <div className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-4 my-4 *:bg-slate-200 *:dark:bg-[#171717] *:dark:border *:border-[#212121] [img]:block">
                    {config.featureEnableCourts && <>
                        <MenuItemCard onPress={() => navigate({to: `/clubs/${params.club_uid}/courts-booking/`})} icon={<Icon icon="material-symbols-light:calendar-clock" className="text-2xl" />} title={'Court Booking'} />
                    </>}
                </div>
            </div>
        </>
    );
}
